import React, { Suspense, lazy } from 'react';
import Navbar from './components/Navbar';
import './App.css';

const Intro = lazy(() => import('./components/Intro'));
const About = lazy(() => import('./components/About'));
const Projects = lazy(() => import('./components/Projects'));
const Credits = lazy(() => import('./components/Credits'));

function App() {
  return (
    <div className="App">
      <Navbar />
      <video 
        className="video-background" 
        src='/assets/bg.mp4' 
        autoPlay 
        loop 
        muted 
        playsInline
      ></video>
        <div className='content'>
          <Suspense fallback={<div>Loading...</div>}>
            <Intro />
            <About />
            <Projects />
            <Credits />
          </Suspense>
        </div>
    </div>
  );
}

export default App;
